"use client";

import { motion } from "framer-motion";

interface DeepActionSectionProps {}

export function DeepActionSection({}: DeepActionSectionProps) {

  return (
    <div className="h-[200vh] bg-transparent relative">
      <div className="sticky top-[60px] h-[calc(100vh-60px)] flex flex-col  ">
        {/* Top Section - Title and Description (Fixed) */}
        <div className="flex-shrink-0 text-center py-8">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <motion.h2 
              className="text-3xl text-white sm:text-4xl font-bold mb-4"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              Automated Complex Web Tasks with One Prompt
            </motion.h2>
            <motion.p 
              className="text-lg text-white/60 max-w-3xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              Automatically execute cross-app workflows through natural language descriptions
            </motion.p>
          </div>
        </div>

        {/* Middle Section - Video (Flexible based on remaining space) */}
        <div className="flex-1 flex items-center justify-center px-6 min-h-0">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="max-w-full max-h-full object-contain rounded-lg"
            style={{
              width: "auto",
              height: "auto",
            }}
          >
            <source src="https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/Website+main+page+animation/Deep+action.webm" type="video/webm" />
          </video>
        </div>
      </div>
    </div>
  );
}
